import { css, styled } from 'styled-components';

export const blockStyle = css`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
`;

export const BaseBlock = styled.div`
  ${blockStyle}
`;
